import React, { useState, useEffect, useRef, useCallback } from "react";
import WelDataService from "../services/WelService";
import { useParams, useNavigate } from 'react-router-dom';
import TransactionTable from "../../components/TransactionTable";

const WelPr = (props) => {
  const [wel, setWel] = useState([]);
  const welRef = useRef();
  welRef.current = wel;

  const { owner } = useParams();
  const navigate = useNavigate();

  const retrieveWel = useCallback((ownerParam) => {
    const target = ownerParam ?? owner;
    WelDataService.getAll(target)
      .then((response) => setWel(response.data || []))
      .catch((e) => { console.error(e); setWel([]); });
  }, [owner]);

  useEffect(() => { retrieveWel(); }, [retrieveWel]);

  const deleteWel = useCallback((rowIndex) => {
    const id = welRef.current[rowIndex].id || welRef.current[rowIndex]._id;
    WelDataService.remove(id)
      .then(() => {
        const newArr = [...welRef.current];
        newArr.splice(rowIndex, 1);
        setWel(newArr);
      })
      .catch((e) => console.error(e));
  }, []);

  const handleView = useCallback((row) => {
    const id = row.id || row._id;
    if (id) navigate(`/dashboard/wel/${id}`);
  }, [navigate]);

  const handleEdit = useCallback((row) => {
    const id = row.id || row._id;
    if (id) navigate(`/dashboard/wel/edit/${id}`);
  }, [navigate]);

  const handleDeleteRow = useCallback((row) => {
    const idx = welRef.current.findIndex(item => (item.id || item._id) === (row.id || row._id));
    if (idx >= 0) deleteWel(idx);
  }, [deleteWel]);

  return (
    <div className="list row">
      <div className="col-md-12 list">
        <TransactionTable
          transactions={wel}
          onView={handleView}
          onEdit={handleEdit}
          onDelete={handleDeleteRow}
          initialPageSize={10}
          showBack={true}
          onBack={() => navigate(-1)}
        />
      </div>
    </div>
  );
};

export default WelPr;
